import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconTitleDescComponent } from 'src/app/shared/components/icon-title-desc/icon-title-desc.component';
import { officeInfos } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-did-not-enough',
  imports: [MatProgressSpinnerModule, IconTitleDescComponent, NgOptimizedImage],
  templateUrl: './did-not-enough.component.html',
  styleUrl: './did-not-enough.component.scss',
})
export class DidNotEnoughComponent {
  readonly officeInfos = officeInfos;
}
